import { useMutation } from "@tanstack/react-query";
import { client } from "./api-client";

/* =========================
   GET ALL (LIST)
========================= */

export const useGetEscalationMatrixAll = () =>
  useMutation({
    mutationFn: (data) =>
      client(`sla/configuration/escalation/matrix/all`, {
        data,
      }),
  });

/* =========================
   ADD
========================= */

export const useAddEscalationMatrix = () =>
  useMutation({
    mutationFn: (data) =>
      client(`sla/configuration/escalation/matrix/add`, {
        data,
        successMessage: "Escalation Matrix added successfully",
      }),
  });

/* =========================
   GET BY ID
========================= */

export const useGetEscalationMatrixDetail = () =>
  useMutation({
    mutationFn: (matrixId) =>
      client(`sla/configuration/escalation/matrix/${matrixId}`),
  });

/* =========================
   EDIT
========================= */

export const usePutEscalationMatrix = () =>
  useMutation({
    mutationFn: ({ id, payload }) =>
      client(`sla/configuration/escalation/matrix/edit/${id}`, {
        method: "put",
        data: payload,
        successMessage: "Escalation Matrix updated successfully",
      }),
  });

/* =========================
   DELETE
========================= */

export const useDeleteEscalationMatrix = () =>
  useMutation({
    mutationFn: (id) =>
      client(`sla/configuration/escalation/matrix/delete/${id}`, {
        method: "delete",
        successMessage: "Escalation Matrix deleted successfully",
      }),
  });
